import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
	ck_u_password,
	ck_u_username,
	defDateFormat,
	empty,
	req_salesman,
	req_csr_activity,
	req_csr_activity_report_download,
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import useCookieHook from "../../Services/useCookieHook";
import MUIDataTable from 'mui-datatables';
import { de } from '../../Helper/Helper';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	dateBtn: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
}));

const tableHead = [
    {
        name: "id",
        label: "ID",
        options: {
            display: false
        }
    },
    {
        name: "salepserson",
        label: "Salesperson",
        options: {
            display: true
        }
    },
    {
        name: "outlet",
        label: "Outlet",
        options: {
            display: false
        }
    },
	{
		name: "organization_name",
		label: "Organization",
		options: {
			display: true
		}
	},
    {
		name: "pic",
		label: "PIC",
		options: {
			display: true
		}
	},
    {
		name: "contact",
		label: "Contact",
		options: {
			display: true
		}
	},
    {
		name: "address",
		label: "Address",
		options: {
			display: true
		}
	},
    {
		name: "cash_sponsor",
		label: "Cash Sponsor",
		options: {
			display: true
		}
	},
    {
		name: "stock_sponsor",
		label: "Stock Sponsor",
		options: {
			display: true
		}
	},
    {
		name: "stock_value",
		label: "Stock Value",
		options: {
			display: true
		}
	},
    {
		name: "purpose_objective",
		label: "Purpose/Objective",
		options: {
			display: true
		}
	},
    {
		name: "request_by",
		label: "Request By",
		options: {
			display: true
		}
	},
    {
		name: "event_type",
		label: "Event Type",
		options: {
			display: true
		}
	},
    {
		name: "remark",
		label: "Remark",
		options: {
			display: true
		}
	},
    {
		name: "total_budget_accruel",
		label: "Total Budget Accruel (RM)",
		options: {
			display: true
		}
	},
    {
		name: "total_used_for_sponsor",
		label: "Total Used For Sponsor (RM)",
		options: {
			display: true
		}
	},
    {
		name: "balance_budget_left",
		label: "Balance Budget Left (RM)",
		options: {
			display: true
		}
	},
	{
		name: "event_date",
		label: "Event Date",
		options: {
			display: true
		}
	},
    {
		name: "prepared_date",
		label: "Prepared Date",
		options: {
			display: true
		}
	},
];

export default function CSRActivity() {
	const commonStyle = useCommonStyles();
	const classes = useStyles();
	const singleton = PersistantData.getInstance();
	const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}

	const [cookies, setCookie] = useCookieHook([ck_u_username, ck_u_password]);
	const {enqueueSnackbar, closeSnackbar} = useSnackbar();

	const [splist, setSPlist] = useState([]);
	const [csrActivityList, setCsrActivityList] = useState([]);
	const [tableHeader, setTableHeader] = useState([]);

	const [csrActivityDateRange, setCsrActivityDateRange] = useState({});
	const [openCsrActivityDateDoc, setOpenCsrActivityDateDoc] = useState(false);
	const [csrActivitySpView, setCsrActivitySpView] = useState(false);
	const [csrActivitySpSelect, setCsrActivitySpSelected] = useState(empty);
	const [csrActivitySalesperson, setCsrActivitySalesperson] = useState(empty);
	const [detailDialog, setDetailDialog] = useState(false);
	const [selectedRowData, setSelectedRowData] = useState({});
	const [imagePreviewDialog, setImagePreviewDialog] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			getSalesmanList(gState.client);
		}
		setTableHeader(tableHead);
	}, [gState.client, gState.translation]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const getSalesmanList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login, login_status} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id, status: parseInt(login_status)});
				}
				setSPlist(_data);
			}
		});
	}

	const getCsrActivityData = (_client = client, shouldExport = false) => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(csrActivityDateRange)) {
			st_date = format(csrActivityDateRange.startDate, defDateFormat);
			st_date_to = format(csrActivityDateRange.endDate, defDateFormat);
		}
		var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: csrActivitySpSelect,
			username: cookies(ck_u_username),
            export: shouldExport,
		};
		if (gState.company) {
			parameters.company = gState.company;
		}
		
		const param = axiosURIencode(parameters);
		if (shouldExport == false) {
			API_Service.get(`${req_csr_activity}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				setCsrActivityList(extraData);
				snack('CSR Activity data loaded successfully', 'success');
			} else {
				setCsrActivityList([]);
				snack(language.no_data, 'warning');
			}
		}).catch(error => {
			console.error('CSR Activity API Error:', error);
			setCsrActivityList([]);
			snack('Failed to load CSR Activity data', 'error');
		});
		} else {
			API_Service.get(`${req_csr_activity}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
				const {result, extraData, message} = data;
				if (result) {
					if (extraData && extraData.url) {
						const link = document.createElement('a');
						link.href = extraData.url;
						link.download = extraData.filename || 'CSR_Activities_Report.xlsx';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						
						snack(message || 'Excel report has been successfully downloaded', 'success');
					} else {
						snack('Failed to download Excel report - No download URL provided', 'error');
					}
				} else {
					snack(message, 'error');
				}
			}).catch(error => {
				console.error('Excel export API Error:', error);
				snack('Failed to download Excel report', 'error');
			});
		}
	}

	const CsrActivitySPViewClick = () => {
		setCsrActivitySpView(true);
	}

	const CsrActivitySPViewClose = (newValue) => {
		setCsrActivitySpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setCsrActivitySpSelected(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setCsrActivitySalesperson(spname);
		}
	}

	const getCsrActivityDate = () => {
		return !_.isEmpty(csrActivityDateRange) ? moment(csrActivityDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(csrActivityDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

	const handleRowClick = (rowData, rowMeta) => {
		const selectedData = csrActivityList[rowMeta.dataIndex];
        console.log('selectedData', selectedData);
		setSelectedRowData(selectedData);
		setDetailDialog(true);
	}

	const handleCloseDetailDialog = () => {
		setDetailDialog(false);
		setSelectedRowData({});
	}

	const handleImageClick = (imageSrc) => {
		setSelectedImage(imageSrc);
		setImagePreviewDialog(true);
	}

	const handleCloseImagePreview = () => {
		setImagePreviewDialog(false);
		setSelectedImage('');
	}

    const downloadAsPDF = (selectedData) => {
        var id = selectedData.id;
        var url = `${req_csr_activity_report_download}?id=${id}`;
        API_Service.get(url, axiosDefaultConfig(client)).then(({data}) => {
            const {result, extraData} = data;
            if (result == true) {
                snack('PDF report has been successfully downloaded', 'success');
                var base64 = extraData.base64;
                var htmlContent = atob(base64);
                
                var newWindow = window.open('', '_blank');
                if (newWindow) {
                    newWindow.document.open();
                    newWindow.document.write(htmlContent);
                    newWindow.document.close();
                } else {
                    snack('Failed to open new window, please check browser popup settings', 'warning');
                }
            } else {
                snack('Failed to download PDF report', 'error');
            }
        }).catch(error => {
            console.error('Error downloading PDF report:', error);
            snack('Failed to download PDF report', 'error');
        });
    }

	return (
		<div>
			<div className={classes.viewInRow}>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => CsrActivitySPViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{csrActivitySalesperson ? _.truncate(csrActivitySalesperson, {length: 20}) : language.salesperson}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenCsrActivityDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getCsrActivityDate()}
					</Typography>
				</Button>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getCsrActivityData(client, false)}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.view}
					</Typography>
				</Button>
				<div style={{width: 10}}/>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getCsrActivityData(client, true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.export || 'CSR Activities Report'}
					</Typography>
				</Button>
			</div>
			<div style={{height: 20}}/>
			{
				csrActivityList.length > 0 && (
					<MUIDataTable
						title="CSR Activity List"
						data={csrActivityList}
						columns={tableHeader}
						options={{
							search: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 25,
							rowsPerPageOptions: [25, 40, 65, 100],
							responsive: 'simple',
							onRowClick: handleRowClick,
						}}
					/>
				)
			}

			<VirtualListCB
				open={csrActivitySpView}
				setClose={data => CsrActivitySPViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
				filteration={1}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setCsrActivityDateRange(range);
					setOpenCsrActivityDateDoc(false)
				}}
				setNegative={() => {
					setOpenCsrActivityDateDoc(false)
				}}
				setClose={() => {
					setOpenCsrActivityDateDoc(false)
				}}
				open={openCsrActivityDateDoc}
				message={language.date_range}
				positive={language.ok}
			/>

			<Dialog
				open={detailDialog}
				onClose={handleCloseDetailDialog}
				maxWidth="md"
				fullWidth>
				<DialogTitle>
					<Typography variant="h6" style={{fontWeight: 'bold', color: 'yellow'}}>CSR Activity Details</Typography>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Organization:</Typography>
							<Typography variant="body1">{selectedRowData.organization_name || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">PIC:</Typography>
							<Typography variant="body1">{selectedRowData.pic || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Contact:</Typography>
							<Typography variant="body1">{selectedRowData.contact || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Address:</Typography>
							<Typography variant="body1">{selectedRowData.address || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Cash Sponsor:</Typography>
							<Typography variant="body1">{selectedRowData.cash_sponsor || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Stock Sponsor:</Typography>
							<Typography variant="body1">{selectedRowData.stock_sponsor || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Stock Value:</Typography>
							<Typography variant="body1">{selectedRowData.stock_value || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="subtitle2" color="textSecondary">Purpose/Objective:</Typography>
							<Typography variant="body1">{selectedRowData.purpose_objective || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Request By:</Typography>
							<Typography variant="body1">{selectedRowData.request_by || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Event Type:</Typography>
							<Typography variant="body1">{selectedRowData.event_type || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="subtitle2" color="textSecondary">Remark:</Typography>
							<Typography variant="body1">{selectedRowData.remark || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Total Budget Accruel (RM):</Typography>
							<Typography variant="body1">{selectedRowData.total_budget_accruel || '0'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Total Used For Sponsor (RM):</Typography>
							<Typography variant="body1">{selectedRowData.total_used_for_sponsor || '0'}</Typography>
						</Grid>
						<Grid item xs={12} sm={4}>
							<Typography variant="subtitle2" color="textSecondary">Balance Budget Left (RM):</Typography>
							<Typography variant="body1">{selectedRowData.balance_budget_left || '0'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Event Date:</Typography>
							<Typography variant="body1">{selectedRowData.event_date || 'N/A'}</Typography>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography variant="subtitle2" color="textSecondary">Prepared Date:</Typography>
							<Typography variant="body1">{selectedRowData.prepared_date || 'N/A'}</Typography>
						</Grid>
					</Grid>
                    {
                        selectedRowData.upload_images && selectedRowData.upload_images.length > 0 && (
                            <Grid item xs={12} style={{marginTop: 16}}>
								<Typography variant="subtitle2" color="textSecondary" style={{marginBottom: 8}}>
									Picture:
								</Typography>
								<Grid container spacing={2}>
									{
										selectedRowData.upload_images.map((image, index) => (
											<Grid item xs={6} sm={4} md={3} key={index}>
												<div
													style={{
														position: 'relative',
														width: '100%',
														paddingBottom: '100%',
														cursor: 'pointer',
														borderRadius: 8,
														overflow: 'hidden',
														boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
														transition: 'transform 0.2s ease, box-shadow 0.2s ease'
													}}
													onClick={() => handleImageClick(image)}
													onMouseEnter={(e) => {
														e.currentTarget.style.transform = 'scale(1.05)';
														e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.2)';
													}}
													onMouseLeave={(e) => {
														e.currentTarget.style.transform = 'scale(1)';
														e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
													}}
												>
													<img 
														src={image} 
														alt={`CSR Activity ${index + 1}`}
														style={{
															position: 'absolute',
															top: 0,
															left: 0,
															width: '100%',
															height: '100%',
															objectFit: 'cover',
															backgroundColor: '#f5f5f5'
														}}
														onError={(e) => {
															e.target.style.display = 'none';
															e.target.nextElementSibling.style.display = 'flex';
														}}
													/>
													<div
														style={{
															position: 'absolute',
															top: 0,
															left: 0,
															width: '100%',
															height: '100%',
															display: 'none',
															alignItems: 'center',
															justifyContent: 'center',
															backgroundColor: '#f5f5f5',
															color: '#666',
															fontSize: '12px'
														}}
													>
														Picture Loading Failed
													</div>
													<div
														style={{
															position: 'absolute',
															bottom: 4,
															right: 4,
															backgroundColor: 'rgba(0,0,0,0.6)',
															color: 'white',
															borderRadius: 4,
															padding: '2px 6px',
															fontSize: '10px',
															fontWeight: 'bold'
														}}
													>
														{index + 1}
													</div>
												</div>
											</Grid>
										))
									}
								</Grid>
                            </Grid>
                        )
                    }
				</DialogContent>
				<DialogActions>
                    <Button onClick={() => downloadAsPDF(selectedRowData)} style={{backgroundColor: 'yellow', color: 'black'}}>
						{'Download as PDF'}
					</Button>
					<Button onClick={handleCloseDetailDialog} color="primary">
						{language.close || 'Close'}
					</Button>
				</DialogActions>
			</Dialog>

			{/* 图片预览对话框 */}
			<Dialog
				open={imagePreviewDialog}
				onClose={handleCloseImagePreview}
				maxWidth="md"
				fullWidth>
				<DialogTitle>
					<Typography variant="h6">Picture Preview</Typography>
				</DialogTitle>
				<DialogContent style={{textAlign: 'center', padding: 20}}>
					{selectedImage && (
						<img
							src={selectedImage}
							alt="CSR Activity Preview"
							style={{
								maxWidth: '100%',
								maxHeight: '70vh',
								objectFit: 'contain',
								borderRadius: 8,
								boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
							}}
							onError={(e) => {
								e.target.style.display = 'none';
								e.target.nextElementSibling.style.display = 'block';
							}}
						/>
					)}
					<div
						style={{
							display: 'none',
							padding: 40,
							color: '#666',
							fontSize: '16px'
						}}
					>
						Picture Loading Failed
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseImagePreview} color="primary">
						{language.close || 'Close'}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}